import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';

class ConfigStorage {
	constructor(defaultValue) {
		this._defaultValue = defaultValue;
		this._storage = defaultValue;
	}

	get(key) {
		return key ? this._storage[key] : this._storage;
	}

	set(value) {
		this._storage = value || this._defaultValue;
	}

	add(key, value) {
		if (typeof value === 'undefined') value = key;
		if (isArray(this._storage)) {
			this._storage.push(value);
		} else if (isObject(this._storage)) {
			this._storage[key] = value;
		} else if (isFunction(this._storage)) {
			// add property
			if(value) {
				Object.defineProperty(this._storage, key, {
					enumerable: true,
					configurable: true,
					get: value
				});
			}
		}
		else {
			this._storage = value;
		}
		return value;
	}
}

export default function create(defaultValue) {
	return new ConfigStorage(defaultValue);
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/internal/configStorage.js